import Api from '../../services/api';
import {
  ALERT_SET,
  GO_TO_STEP,
  MESSAGES_SET,
  OTHER_CONTENT,
  OTHER_CONTENT_FAILURE,
  OTHER_CONTENT_SUCCESS,
  PAYGATE_MESSAGES_SET,
  RESET_PARAMS,
  SET_DATA_TO_STEP,
  SET_STEP,
  SET_TICKET_ID,
} from './constants';

const setStepFinally = (step, data) => {
  return {
    type: SET_STEP,
    payload: step,
    data,
  };
};

export const setStep = (step, data) => {
  return dispatch => {
    dispatch(setStepFinally(step, data));
  };
};

export const setParamsToStep = data => {
  return {
    type: SET_DATA_TO_STEP,
    data,
  };
};

export const goToStep = step => ({
  type: GO_TO_STEP,
  payload: step,
});

export const resetStepParams = () => ({
  type: RESET_PARAMS,
});

export const setTicketId = id => ({
  type: SET_TICKET_ID,
  payload: id,
});

export const otherContentRequest = id => ({
  type: OTHER_CONTENT,
  payload: {
    id,
  },
});

export const otherContentSuccess = (id, name, body) => ({
  type: OTHER_CONTENT_SUCCESS,
  payload: {
    id,
    name,
    body,
  },
});

export const otherContentFailure = id => ({
  type: OTHER_CONTENT_FAILURE,
  payload: {
    id,
  },
});

export const loadOtherContentById = id => {
  return async dispatch => {
    dispatch(otherContentRequest(id));
    try {
      const response = await Api.getOtherContent(id);
      dispatch(otherContentSuccess(id, response.name, response.body));
    } catch (e) {
      dispatch(otherContentFailure(id));
    }
  };
};

export const setAlert = configuration => ({
  type: ALERT_SET,
  payload: {
    configuration: { ...configuration, show: true },
  },
});

export const hideAlert = () => ({
  type: ALERT_SET,
  payload: {
    configuration: {
      title: '',
      show: false,
    },
  },
});

export const errorAlert = (title, text = '', onConfirm = null) => {
  return dispatch => {
    dispatch(
      setAlert({
        type: 'error',
        title,
        text,
        onConfirm:
          typeof onConfirm === 'function'
            ? onConfirm
            : () => {
                dispatch(hideAlert());
              },
      }),
    );
  };
};

export const okAlert = (title, text = '', onConfirm = null) => {
  return dispatch => {
    dispatch(
      setAlert({
        type: 'success',
        title,
        text,
        onConfirm:
          typeof onConfirm === 'function'
            ? onConfirm
            : () => {
                dispatch(hideAlert());
              },
      }),
    );
  };
};

const setMessages = messages => {
  return {
    type: MESSAGES_SET,
    payload: {
      messages,
    },
  };
};

export const loadMessages = () => {
  return async dispatch => {
    try {
      const response = await Api.getMessages();
      dispatch(setMessages(response.results || []));
    } catch (e) {
      //
    }
  };
};

const setPaygateMessages = messages => {
  return {
    type: PAYGATE_MESSAGES_SET,
    payload: {
      messages,
    },
  };
};

export const loadPaygateMessages = () => {
  return async dispatch => {
    try {
      const response = await Api.getPaygateMessages();
      dispatch(setPaygateMessages(response.results || []));
    } catch (e) {
      //
    }
  };
};



// WEBPACK FOOTER //
// ./src/containers/App/actions.js